import axios, { AxiosError, AxiosRequestHeaders } from "axios";
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  readOnlyRequestInterceptor,
  readOnlyResponseErrorInterceptor,
  isReadOnlyError,
  isBackendReadOnlyResponse,
} from "../common/migration/readOnlyGuard";
import { READ_ONLY_TOAST_COPY } from "../common/migration/constants";

export const JSONRequestHeaders: AxiosRequestHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
};

export const MultipartRequestHeaders: AxiosRequestHeaders = {
  "Content-Type": "multipart/form-data",
};



// Http Request Default Configurations
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.headers.common = {
  ...JSONRequestHeaders,
};

// Read-only enforcement for migrated employers. No-op (byte-for-byte identical
// to today) until MigrationStatusProvider calls migrationStore.setMigrated(true).
axios.interceptors.request.use(readOnlyRequestInterceptor);
axios.interceptors.response.use(undefined, readOnlyResponseErrorInterceptor);

export const HttpClientError = (errors: AxiosError | null): string => {
  if (isReadOnlyError(errors) || isBackendReadOnlyResponse(errors)) {
    return READ_ONLY_TOAST_COPY;
  }
  if (errors && errors.response) {
    // eslint-disable-next-line no-console
    console.log("Network Error : ====> \n", errors.response);
    switch (errors.response.status) {
      case 400:
      case 401:
      case 409:
      case 403:
      case 405:
      case 422:
      case 429:
        // eslint-disable-next-line no-prototype-builtins
        if(errors.response.data.hasOwnProperty("message")){
          return errors.response.data.message
        }

        return errors.response.data.detail;
      case 500:
        return "Submission failed, please try again later."
      default:
        return errors.response.data;
    }
  } else if (errors && errors.request) {
    // eslint-disable-next-line no-console
    console.log("Request errors: ====> \n", errors.request);
    return errors.request.response;
  } else if (errors) {
    return errors.message;
  }

  return "InternalServerErrorPage";
};
